import Boxplot, { computeBoxplotStats } from "react-boxplot";
import { ORDER } from "../utils/constants";
import CareerIcon from "./career-icon";
import NumericLabel from "react-pretty-numbers";

const CareerRow = ({
  career,
  careers,
  outliers,
  metric,
  method,
  solo,
  limitKills = 0,
  limitDied = 1,
  showHistogram = false,
  scale = 1,
  showAverages,
}) => {
  if (careers.length < 11) {
    return null;
  }
  const killLimt = solo == "only-solo" ? 0 : limitKills;
  const deathLimit = solo == "only-solo" ? 2 : limitDied;

  const getKills = (c) => {
    return c.kills;
  };

  const getDeaths = (c) => {
    return c.died;
  };

  const getAssists = (c) => {
    return c.assists;
  };

  const getDamage = (c) => {
    return c.damage;
  };

  const classFilter = (c) => {
    /*if (solo == "only-solo") {
      if (getDeaths(c) >= deathLimit || getKills(c) >= killLimt) {
        return true;
      }
    }*/
    if (getKills(c) >= killLimt && getDeaths(c) >= deathLimit) {
      return true;
    }
  };

  const filtered = careers.filter((c) => classFilter(c));

  if (filtered.length < 3) {
    return null;
  }

  const careerValues = (cvalues) => {
    switch (metric) {
      case "kills:died":
        return cvalues
          .filter((c) => classFilter(c))
          .map((c) => getKills(c) / getDeaths(c));
      case "killsassists:died":
        return cvalues
          .filter((c) => classFilter(c))
          .map((c) => (getKills(c) + getAssists(c)) / getDeaths(c));
      case "damage":
        return cvalues
          .filter((c) => classFilter(c))
          .map((c) => getDamage(c) / getDeaths(c));
      case "damage-per-contr":
        return cvalues
          .filter((c) => classFilter(c) && c.damage > 0)
          .map((c) => getDamage(c) / (getKills(c) + getAssists(c)));
      /*case "damage-per-contr":
        return cvalues
          .filter((c) => classFilter(c))
          .map((c) => getDamage(c) / getKills(c));

          */
      default:
        return [];
    }
  };

  const mean = () => {
    switch (metric) {
      case "kills:died":
        return (totals("kills") / totals("died")).toFixed(2);
      case "killsassists:died":
        return ((totals("kills") + totals("assists")) / totals("died")).toFixed(
          2
        );
      case "damage":
        return (totals("damage") / totals("died")).toFixed(0);
      case "damage-per-contr":
        return (
          totals("damage") /
          (totals("kills") + totals("assists"))
        ).toFixed(0);

      default:
        return "-";
    }
  };

  const median = (cvalues) => {
    const filtered = cvalues.filter((c) => classFilter(c));
    let sorted, nvalues, q1, q3, iqr, filteredValues;

    switch (metric) {
      case "kills:died":
        sorted = filtered.sort(
          (a, b) => getKills(a) / getDeaths(a) - getKills(b) / getDeaths(b)
        );

        var q1char = sorted[Math.floor(sorted.length / 4)];

        var q3char = sorted[Math.ceil(sorted.length * (3 / 4))];
        q1 = q1char.kills / q1char.died;
        q3 = q3char.kills / q3char.died;
        iqr = q3 - q1;
        var maxValue = q3 + iqr * 1.5;
        var minValue = q1 - iqr * 1.5;
        filteredValues = sorted.filter(
          (x) => x.kills / x.died <= maxValue && x.kills / x.died >= minValue
        );

        nvalues = Math.round(filteredValues.length / 2);

        return (
          getKills(filteredValues[nvalues]) / getDeaths(filteredValues[nvalues])
        ).toFixed(2);

      case "killsassists:died":
        sorted = filtered.sort(
          (a, b) =>
            (a.kills + a.assists) / a.died - (b.kills + b.assists) / b.died
        );
        var q1char = sorted[Math.floor(sorted.length / 4)];
        var q3char = sorted[Math.ceil(sorted.length * (3 / 4))];
        q1 = (q1char.kills + q1char.assists) / q1char.died;
        q3 = (q3char.kills + q3char.assists) / q3char.died;
        iqr = q3 - q1;
        var maxValue = q3 + iqr * 1.5;
        var minValue = q1 - iqr * 1.5;

        filteredValues = sorted.filter(
          (x) => x.kills / x.died <= maxValue && x.kills / x.died >= minValue
        );

        nvalues = Math.round(filteredValues.length / 2);

        if (filteredValues.length > 0) {
          return (
            (filteredValues[nvalues].kills + filteredValues[nvalues].assists) /
            filteredValues[nvalues].died
          ).toFixed(2);
        } else {
          console.log(filtered);
          console.log(q1, q3, iqr);
          return "-";
        }

      case "damage":
        sorted = filtered.sort((a, b) => a.damage / a.died - b.damage / b.died);
        var q1char = sorted[Math.floor(sorted.length / 4)];
        var q3char = sorted[Math.ceil(sorted.length * (3 / 4))];

        q1 = q1char.damage / q1char.died;
        q3 = q3char.damage / q3char.died;
        iqr = q3 - q1;
        var maxValue = q3 + iqr * 1.5;
        var minValue = q1 - iqr * 1.5;

        filteredValues = sorted.filter(
          (x) => x.kills / x.died <= maxValue && x.kills / x.died >= minValue
        );

        nvalues = Math.round(filteredValues.length / 2);
        if (filteredValues.length > 0) {
          return (
            (
              filteredValues[nvalues].damage / filteredValues[nvalues].died
            ).toFixed() + "%"
          );
        } else {
          console.log(filtered);
          console.log(q1, q3, iqr);
          return "-";
        }

      default:
        return "-";
    }
  };

  const orderBlue = `rgb(14,165,233)`;
  const destroRed = `rgb(293,68,68)`;
  const rorOrange = `rgb(255,153,0)`;

  const svgColor = (career) => {
    if (ORDER.includes(career) || career.includes("ORDER")) {
      return orderBlue;
    }
    if (career.includes("ROR")) {
      return rorOrange;
    }
    return destroRed;
  };

  const getMax = () => {
    switch (metric) {
      case "kills:died":
        return 18 * scale;
      case "killsassists:died":
        return 50 * scale;
      case "damage":
        return 530 * scale;
      case "damage-per":
        return 10000 * scale;
      case "damage-per-contr":
        return 50 * scale;
      default:
        return "-";
    }
  };

  const totals = (key) => {
    return filtered.reduce((a, v) => (a = a + v[key]), 0);
  };

  const average = (key) => {
    return filtered.reduce((a, v) => (a = a + v[key]), 0) / filtered.length;
  };

  const XHistogram = ({ values }) => {
    const bg = "w-1";

    const max = getMax();
    const nBins = 20;
    const binSize = max / nBins;
    const bins = Array.apply(null, Array(nBins)).map(function (x, i) {
      return i * binSize;
    });

    return (
      <div
        className="flex space-x-0 items-baseline"
        //style={{ borderBottom: "0.5px solid gray" }}
      >
        {bins.map((bin) => {
          const heightMult = 0.25; //values.length / 40000;
          const height =
            values.filter((c) => c >= bin && c < bin + binSize).length *
            heightMult;

          return (
            <div
              className={bg}
              style={{
                height: height + "px",
                backgroundColor: svgColor(career),
              }}
            ></div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="w-full bg-gry-400 px-2 py-3 grid grid-cols-12 md:gap-2 gap-1 ">
      <div className="md:col-span-1 flex">
        <div className="w-6">
          <CareerIcon career={career} />
        </div>
        <div className="md:ml-2 hidden md:block lowercase">
          <span style={{ textTransform: "capitalize" }}>
            {career.replace("_", " ")}
          </span>
          <span className="text-xxs ml-2 text-white relative -top-0.5">
            x{filtered.length}
          </span>
        </div>
      </div>
      {showAverages === "average" ? (
        <>
          <div className="text-center hidden md:block mx-auto">
            {average("kills").toFixed(0)}
          </div>
          <div className="text-center hidden md:block mx-auto">
            {average("assists").toFixed(0)}
          </div>

          <div className="text-center hidden md:block mx-auto">
            {average("damage").toFixed(0)}
          </div>
          <div className="text-center hidden md:block mx-auto">
            {average("died").toFixed(0)}
          </div>
        </>
      ) : (
        <>
          <div className="text-center hidden md:block mx-auto">
            <NumericLabel
              params={{ shortFormat: true, shortFormatMinValue: 9999 }}
            >
              {totals("kills")}
            </NumericLabel>
          </div>

          <div className="text-center hidden md:block  mx-auto">
            <NumericLabel
              params={{ shortFormat: true, shortFormatMinValue: 9999 }}
            >
              {totals("assists")}
            </NumericLabel>
          </div>
          <div className="text-center hidden md:block mx-auto">
            <NumericLabel
              params={{ shortFormat: true, shortFormatMinValue: 9999 }}
            >
              {totals("damage", false)}
            </NumericLabel>
          </div>
          <div className="text-center hidden md:block  mx-auto">
            <NumericLabel
              params={{ shortFormat: true, shortFormatMinValue: 9999 }}
            >
              {totals("died")}
            </NumericLabel>
          </div>
        </>
      )}
      <div className="text-center">{mean()}</div>
      <div className="text-center">{median(careers)}</div>
      {showHistogram && (
        <div className="col-span-1 flex items-end">
          <XHistogram values={careerValues(careers)} />
        </div>
      )}
      <div className="col-span-4">
        <Boxplot
          width={600}
          height={20}
          orientation="horizontal"
          min={0}
          max={getMax()}
          stats={computeBoxplotStats(careerValues(careers))}
          outlierRadius={outliers ? 2 : 0}
          outlierStyle={{ fill: svgColor(career) }}
          boxStyle={{ fill: svgColor(career) }}
          whiskerStyle={{ stroke: svgColor(career) }}
          whiskerStrokeWidth={3}
          tickStyle={{ stroke: svgColor(career) }}
        />
      </div>
    </div>
  );
};

export default CareerRow;
